import React from "react";
import { Flex, Spinner } from "@chakra-ui/react";

const LoadingPlaceholder = ({color = "black", ...props}) => {
    return (
        <Flex
            flex={1}
            w='100%'
            h='100%'
            justifyContent='center'
            alignItems='center'
            {...props}
        >
            <Spinner color={color} size='lg'/>
        </Flex>
    )
}

export default LoadingPlaceholder;